/**
 * migrateDepotCapacities — 25/07/2026 (retour user prod : transfert vers
 * le dépôt Paris refusé « saturé 5 places » avec un seul camion garé).
 * La capacité de base des dépôts passe de 5 à 10 (DEFAULT_DEPOT_CAPACITY).
 * Remet à niveau les dépôts persistés dans les anciennes sauvegardes,
 * appelé au rehydrate (gameStore.onRehydrateStorage).
 */
import { DEFAULT_DEPOT_CAPACITY } from '../../data/depotEconomics';

export function migrateDepotCapacities(ownedDepots = []) {
  let changed = false;
  const next = (ownedDepots || []).map(d => {
    if ((d.capacityVehicles || 0) >= DEFAULT_DEPOT_CAPACITY) return d;
    changed = true;
    return { ...d, capacityVehicles: DEFAULT_DEPOT_CAPACITY };
  });
  return changed ? next : ownedDepots;
}
